import React from 'react';
import { Permission } from '../../types/roles';
import { usePermissions } from '../../hooks/usePermissions';

interface PermissionGuardProps {
  permissions: Permission[];
  type?: 'all' | 'any';
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const PermissionGuard: React.FC<PermissionGuardProps> = ({
  permissions,
  type = 'any',
  children,
  fallback = null,
}) => {
  const { hasAllPermissions, hasAnyPermission } = usePermissions();

  const hasAccess = type === 'all' 
    ? hasAllPermissions(permissions)
    : hasAnyPermission(permissions);

  if (!hasAccess) return <>{fallback}</>;

  return <>{children}</>;
};